import { useLocalSessionId, useMediaTrack } from '@daily-co/daily-react';
import { useEffect, useRef } from 'react';
import { useDeepgramDebug } from '../../context/DeepgramDebugContext';
import { useTranscricao } from '../../context/TranscricaoContext';
import { useAudioPipeline } from '../../hooks/useAudioPipeline';
import { useTranscricaoService } from '../../hooks/useDeepgramSocket';

export default function AudioTranscriberSeeder() {
  const localSessionId = useLocalSessionId();
  const audioTrack = useMediaTrack(localSessionId, 'audio');
  const { addTranscription } = useTranscricao();
  const lastTranscriptRef = useRef('');
  const { init: initAudio, cleanup: cleanupAudio } = useAudioPipeline();
  const { dispatch } = useDeepgramDebug();

  const { connect, send, disconnect } = useTranscricaoService({
    onTranscript: (t) => {
      if (t !== lastTranscriptRef.current) {
        lastTranscriptRef.current = t;
        addTranscription(t);
        dispatch({ type: 'TRANSCRIPT', timestamp: Date.now(), message: `Transcrição final recebida (${t.text?.length || 0} chars)` });
      }
    },
    onDebug: (action) => dispatch({ ...action, timestamp: action.timestamp || Date.now() }),
  });

  useEffect(() => {
    if (!audioTrack?.track) return;

    const socket = connect();
    socket.onopen = () => {
      initAudio(audioTrack.track, (buffer) => {
        send(buffer);
        dispatch({
          type: 'FRAME',
          bytes: buffer?.byteLength || 0,
          timestamp: Date.now(),
        });
      });
    };

    return () => {
      cleanupAudio();
      disconnect();
    };
  }, [audioTrack?.track]);

  return null;
}
